export default __webpack_public_path__ + "static/media/gbic.a6eae999.png";